// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__82qAT","button":"Pagination_button__IlvgQ","arrow-button":"Pagination_arrow-button__Sn3uB","arrow":"Pagination_arrow__WeRxb"};